<template>
  <div>
    <el-dialog :width="width" v-bind="$attrs" @close="close" :visible="visible" destroy-on-close>
      <template #header>
        <slot name="header"></slot>
      </template>
      <slot></slot>
      <template #footer>
        <slot name="footer"></slot>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: () => true
    },
    width: {
      type: String,
      default: '30%'
    }
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped></style>
